import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const FETCH_PRACTICE_PLAY_REQUEST = 'FETCH_PRACTICE_PLAY_REQUEST';
export const FETCH_PRACTICE_PLAY_SUCCESS = 'FETCH_PRACTICE_PLAY_SUCCESS';
const FETCH_PRACTICE_PLAY_FAILURE = 'FETCH_PRACTICE_PLAY_FAILURE';

const buildPracticePlayUrl = (groupId) => buildUrl(`/groups/${groupId}/practice-play`);

export function fetchPracticePlayIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildPracticePlayUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchPracticePlay(groupId));
  };
}

export function fetchPracticePlay(groupId) {
  return (dispatch) => {
    const url = buildPracticePlayUrl(groupId);
    const method = 'GET';

    return dispatch(fetchPracticePlayRequest()).payload
      .then((response) => dispatch(fetchPracticePlaySuccess(response)))
      .then((error) => fetchPracticePlayFailure(error));

    function fetchPracticePlayRequest() {
      return ApiCall.createAction({
        type: FETCH_PRACTICE_PLAY_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchPracticePlaySuccess(response) {
      return ApiCall.createAction({
        type: FETCH_PRACTICE_PLAY_SUCCESS,
        payload: response,
        groupId,
        method,
        url,
      });
    }

    function fetchPracticePlayFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PRACTICE_PLAY_FAILURE,
        error,
        method,
        url,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/PracticePlay/actions.js